import InscriptionForm from "../components/Form/inscription";

export default function Inscription({}) {
    return (
      <InscriptionForm />
    );
  }